import { EventEmitter, Injectable, NgZone } from '@angular/core';
import { StorageService } from './storage.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, first } from 'rxjs';
import { InstallationService } from './installation.service';
import { State } from '../models/state';
import { environment } from 'src/environments/environment';
import { ControlService } from './control.service';
import * as Promise from 'bluebird';

@Injectable({
  providedIn: 'root'
})
export class InstallService {
  private baseUrl: any = environment.baseUrl;
  // dataUpdated = new EventEmitter(); //
  dataUpdated: EventEmitter<any> = new EventEmitter<any>();
  dataApkUpload: EventEmitter<any> = new EventEmitter<any>();


  // private htmlContentSubject = new BehaviorSubject()
  constructor(
    private storageService: StorageService,
    private http: HttpClient,
    private control: ControlService
  ) { }


  public installUrl(control, url) {
    let state = new State();
    state.stateName = 'downloading';
    let installation = new InstallationService(state.stateName)
    // $rootScope.$broadcast('installation', installation)
    return control.uploadUrl(url)
      .progress((uploadResult) => {
        installation.update(uploadResult.progress / 2, uploadResult.lastData)
      })
      .then((uploadResult) => {
        installation.update(uploadResult.progress / 2, uploadResult.lastData)
        installation.manifest = uploadResult.body
        return control.install({
          href: installation.href
          , manifest: installation.manifest
          , launch: installation.launch
        })
          .progress((result) => {
            installation.update(50 + result.progress / 2, result.lastData)
          })
      })
      .then(function () {
        installation.okay('installed')
      })
      .catch(function (err) {
        installation.fail(err.code || err.message)
      })
  }
  public installFile(control, file, device: any): Promise<any> {
    const state = new State();
    state.stateName = 'uploading';
    const installation = new InstallationService(state.stateName);
    const isIOSPlatform = device.platform === 'iOS';

    return (this.storageService.storeFile('apk', file, device.deviceSerial, {
      filter: (file) => isIOSPlatform
        ? /\.(ipa)$/i.test(file.name)
        : /\.(apk|aab)$/i.test(file.name)
    }) as any)
      .then((response: any) => response.json())
      .then(async (data) => {
        installation.href = data.resources.file.href;
        installation.update(50, 'processing');
        this.dataApkUpload.emit(installation);

        try {
          if (isIOSPlatform) {
            installation.manifest = { 'application': { 'activities': {} } };
          } else {
            // Retrieve Android manifest
            const manifestResponse = await this.http.get<any>(`${this.baseUrl}${installation.href}/manifest`).toPromise();
            if (manifestResponse && (manifestResponse.success === true || manifestResponse.success === 'true')) {
              installation.manifest = manifestResponse.manifest;
              this.dataUpdated.emit(manifestResponse);
            } else {
              throw new Error('Unable to retrieve manifest');
            }
          }

          // Trigger installation
          return control.install({
            href: installation.href,
            manifest: installation.manifest,
            launch: installation.launch
          })
            .progress((result) => {
              installation.update(50 + (result.progress || 0) / 2, result.lastData || 'installing');
              this.dataApkUpload.emit(installation);
            })
            .then((data) => {
              installation.okay('installed');
              this.dataApkUpload.emit(installation);
            })
            .catch((err) => {
              console.warn('Device installation failed:', err.code || err.message);
              installation.fail(err.code || err.message || 'INSTALL_EXCEPTION');
              this.dataApkUpload.emit(installation);
            });

        } catch (err) {
          console.error('Installation sub-step failed:', err);
          installation.fail(err.code || err.message || 'Installation failed');
          this.dataApkUpload.emit(installation);
          throw err;
        }
      })
      .catch((error) => {
        console.error('Error during installation process:', error);
        installation.fail(error.message || 'Installation process failed');
        this.dataApkUpload.emit(installation);
      });
  }
}
